<template>
  <div>
    <Sidebar v-if="isAuthenticated()"/>
    <div id="app" :class="getAppClass()">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import { isAuthed } from '@/utils'
export default {
  name: 'App',

  components: {
    Sidebar
  },

  methods: {
    isAuthenticated () {
      return isAuthed();
    },

    getAppClass () {
      let publicRoutes = ['Home', 'Login', 'Promo', 'Privacy'];
      let className = 'page-container';
      if (publicRoutes.includes(this.$route.name)) {
        className = className + " exterior-page";
      }

      return className;
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/css/variables";

html, body {
  margin: 0;
}

#app {
  font-family: 'Rubik', sans-serif;
  background: $dark;
  height: 100vh;
}

.exterior-page {
  width: 100% !important;
  margin-left: 0px !important;
}

.body-wrapper {
  flex: 1;
  background: $dark;
  width: calc(100% - #{$sidebar-width});
  position: relative;
  padding-left: $sidebar-width;
  overflow: hidden;
}

.vdatetime {
  input {
    height: 40px;
    background: $sec0;
    color: white;
    border: 0;
    border-radius: 0;
    padding: 0 12px;
    width: 100%;
    box-sizing: border-box;
  }
}

.toasted {
  font-family: 'Rubik', sans-serif;
}

.vue-simple-context-menu {
  background-color: $sec2 !important;
  font-family: 'Rubik', sans-serif;

  .vue-simple-context-menu__item {
    color: $sec6;
    font-size: $font-size-small;
    text-transform: uppercase;
  }
}

.swal2-popup {
  background: $sec0 !important;
  width: 22em !important;

  .swal2-header {
    align-items: start;
  }

  .swal2-title {
    font-family: 'Rubik', sans-serif;
    color: $sec7;
    font-size: $font-size-medium;
    text-align: left;
  }

  #swal2-content {
    font-family: 'Rubik', sans-serif;
    color: $sec4;
    text-align: left;
    font-size: $font-size-small;
  }

  .swal2-cancel {
    font-family: 'Rubik', sans-serif;
    border-radius: 0 !important;
    background-color: transparent !important;
    border: 1px solid $sec3 !important;
    color: $sec3 !important;
    font-weight: bold !important;
  }

  .swal2-confirm {
    font-family: 'Rubik', sans-serif;
    border-radius: 0 !important;
    background-color: $blue !important;
    font-weight: bold !important;
  }
}
</style>
